import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
  layout: {
    // `stretch` (no flex-start): la columna de contenido tiene que poder ocupar todo el
    // alto del area disponible para que una vista full-height —el chat de Niko— se
    // estire hasta el footer. Las vistas normales no cambian: sus hijos conservan el
    // alto natural y solo queda espacio libre debajo.
    alignItems: 'stretch',
    backgroundColor: 'transparent',
  },
  main: {
    backgroundColor: theme.palette.custom.light,
    overflow: 'hidden'
  },
}));
